import { Breadcrumbs } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { notifySet } from '../../Services/Actions/CommonActions';
import { addPlan } from '../../Services/Utils/PlanApis';
import PlanForm from './PlansForm';

function AddPlan() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [serviceProviders, setServiceProviders] = useState([]);
  const onButtonClick = (formData) => {
    const data = {
      name: formData.name,
      serviceProviderViews: serviceProviders
    };
    addPlan(data).then((res) => {
      const { hasError, message } = res;
      if (hasError === false) {
        navigate('/plans');
        dispatch(notifySet({ type: 'success', message }));
      } else if (hasError === true) {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  return (
    <div className="container-fluid ">
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/plans">Plans</Link>
          <Link to="#">Add Plan</Link>
        </Breadcrumbs>
      </div>
      <div className="row">
        <PlanForm
          buttonSaveText="Add Plan"
          onButtonClick={onButtonClick}
          planText="Add Plan"
          serviceProviders={serviceProviders}
          setServiceProviders={setServiceProviders}
        />
      </div>
    </div>
  );
}

export default AddPlan;
